import { useQuery } from '@tanstack/react-query';

import { serviceApi } from '~/features';
import { ActiveCampaignProps } from '~/types/activeCampaign';

export const GET_ACTIVE_CAMPAIGNS_QUERY_KEY = 'GET_ACTIVE_CAMPAIGNS_QUERY';

async function getActiveCampaigns(manufacturerId?: number | null) {
  const params = manufacturerId ? { manufacturerId } : undefined;
  const response = await serviceApi.get<ActiveCampaignProps[]>(
    '/Campanha/ActiveCampaigns?ProjectAdsId=1',
    { params }
  );
  return response;
}

export function useGetActiveCampaigns(manufacturerId?: number | null) {
  return useQuery({
    queryKey: [GET_ACTIVE_CAMPAIGNS_QUERY_KEY, manufacturerId],
    queryFn: () => getActiveCampaigns(manufacturerId),
    select: data => data?.data || [],
  });
}

export type UseGetActiveCampaignsReturn = ReturnType<
  typeof useGetActiveCampaigns
>['data'];
